module.exports = __webpack_public_path__ + "img/creating-api-healthchecks.584fc9ca.png";